import { ButtonHTMLAttributes, ElementType, ReactNode } from "react";
import { twMerge } from 'tailwind-merge'

interface ElementProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: ElementType,
    qtd: number,
    text?: string,
    children?: ReactNode,
}

export function  Notification({ icon: Icon, text, children,qtd, ...rest }: ElementProps) {
    return (
        <button
            type="button"
            {...rest}
            className={twMerge("flex tw-min-w-[300px] tw-max-w-[350px] tw-pb-0.5 tw-pt-1 tw-font-bold tw-text-lg  tw-bg-[#ED636E] tw-text-white hover:tw-bg-[#E13441] tw-rounded-lg", rest.className)}
        >
            <div className={twMerge('tw-w-[25px] tw-mx-2 tw-text-center tw-h-[25px] tw-text-[#ED636E] hover:tw-text-[#E13441] tw-rounded-full',qtd > 0 ? 'tw-bg-white' : '')}>
                {qtd > 0 ?  qtd : ''}
            </div>
            {children}
            {Icon && <Icon />}

        </button>
    )
}